import { BrokerProduct } from '../../../services/brokers/types.ts';
import { ProductCard } from './product-card.component.tsx';

export type ProductsGridProps = {
  products: BrokerProduct[];
};

export function ProductsGrid({ products }: ProductsGridProps) {
  return (
    <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
      {products.map(product => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}
